module.exports = __webpack_public_path__ + "static/media/cityright.49b30845.webp";